import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import theme from '../../styles/theme';

const MainWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    // border-radius: 12px;
    padding: 0.6rem 0px;
    height: 2rem;
    min-width: 3rem;
    line-height: 1.2rem;
    font-weight: 600;
    color: #efefef;
    background: ${(props)=>props.color ? props.color : '#dddddd'};
    span {
        font-size: 1rem;
    }
`;


const ProjectStatusLabel = (props) => {
    const {status, value} = props;
    const [color, setColor] = useState();
    const [viewText, setViewText] = useState();
    useEffect(()=>{
        if(status){
            let targetColor = theme.color.white[100];
            let targetText = '';
            switch(status){
                case 'Q':
                case 'R':
                    targetColor = theme.color.secondary.blueA;
                    targetText = '준비';
                    break;
                case 'I':
                    targetColor = theme.color.setting2;
                    targetText = '설치';
                    break;
                case 'S':
                    targetColor = theme.color.coding2;
                    targetText = '코딩';
                    break;
                case 'E':
                    targetColor = theme.color.complete2;
                    targetText = '완료';
                    break;
                case 'A':
                    targetColor = '#e2614d';
                    targetText = '긴급';
                    break;
                default : 
                    targetColor = theme.color.secondary.blueA;
                    break;
            }
            setColor(targetColor);
            setViewText(value?value:targetText);
        }
    },[status])
    return (
        <MainWrap color={color}>
            <span>{viewText}</span>
        </MainWrap>
    )
}

export default ProjectStatusLabel;
